import { formattedPrice } from 'src/utils/common'

export interface CurrencyType {
  symbol: string
  label: string
  code: string
}

interface Currencies {
  [key: string]: CurrencyType
}

const currencies: Currencies = {
  NZD: {
    symbol: '$',
    label: 'New Zealand Dollars',
    code: 'NZD'
  }
}
const defaultCurrency = 'NZD'

export interface CurrencyProps {
  amount: number | string
  code?: string
  showCents?: boolean
}

export const Currency = ({
  amount,
  code = defaultCurrency,
  showCents = true
}: CurrencyProps) => {
  const parsedAmount: number =
    typeof amount === 'string' ? parseFloat(amount.replace(/,/g, '')) : amount
  const formattedAmount: string = formattedPrice({ price: amount, showCents })

  const renderCurrencyCode = () => {
    return (
      <abbr className='sr-only' title={currencies[code]?.label}>
        {code}
      </abbr>
    )
  }

  return (
    <>
      {`${Math.sign(parsedAmount) === -1 ? '-' : ''}${
        currencies[code]?.symbol
      }${formattedAmount}`}
      {renderCurrencyCode()}
    </>
  )
}
